import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import {
  FormError,
  TextAreaInput,
  Title,
  UploadInput,
} from "../../../components";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { handleFormServerErrors } from "../../../helpers/errorHandling";
import { useValidators } from "../../../helpers/validation";
import SubmitButton from "../../../components/forms/SubmitButton";
import { useAddRequestMessageMutation } from "../queries";
import { MAIN_API_ROOT } from "../../../app_config";
import { useState } from "react";
import { CPRequestStateChange } from "../../../api/models/unified";

interface RequestMessageFormProps {
  requestId: string;
}

export interface RequestMessageFormValues {
  changeStateTo?: CPRequestStateChange | null;
  message: string;
  attachmentIds: string[];
}

const RequestMessageForm = ({ requestId }: RequestMessageFormProps) => {
  const { tRequest, tError, t } = useCustomTranslation();
  const validators = useValidators();

  const [uploadKey, setUploadKey] = useState(0);
  const [isAttachmentsUploading, setIsAttachmentsUploading] = useState(false);

  const addRequestMessageMutation = useAddRequestMessageMutation();

  const methods = useForm<RequestMessageFormValues>({
    mode: "onBlur",
  });

  const onSubmit: SubmitHandler<RequestMessageFormValues> = async (data) => {
    try {
      await addRequestMessageMutation.mutateAsync({ requestId, values: data });
      methods.reset();
      // Changing the key of the UploadInput causing the remount of the component
      setUploadKey((key) => key + 1);
    } catch (e) {
      handleFormServerErrors(e, tError, methods.setError);
    }
  };

  const { handleSubmit } = methods;

  return (
    <div className="mt-8">
      <Title title={tRequest("message")} className="mb-4" />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <TextAreaInput
            name="message"
            placeholder={tRequest("message_placeholder")}
            required
            options={{
              required: validators.required,
            }}
            className="h-[250px]"
          />
          <UploadInput
            multiple
            name="attachmentIds"
            uploadPath={`${MAIN_API_ROOT}/customerPortal/request/v2/attachment`}
            key={uploadKey}
            onUploadingChange={setIsAttachmentsUploading}
          />
          <FormError />
          <div className="mt-6 flex flex-col sm:flex-row sm:justify-end">
            <div className="flex flex-row gap-6">
              <SubmitButton
                label={t("send")}
                icon="arrow-right"
                isDisabled={isAttachmentsUploading}
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default RequestMessageForm;
